import {
  Box,
  /* WhatsApp sunset 2026-03-14 — channel deactivated, web chat is sole channel */
  // Chip,
  // MenuItem,
  TableBody,
  TableCell,
  TableRow,
  // FormControl,
  // InputLabel,
  // Select,
  // SelectChangeEvent
} from "@mui/material";
/* WhatsApp sunset 2026-03-14 — channel deactivated, web chat is sole channel */
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";
import React, { useEffect } from "react";
import Moment from "react-moment";
import Loader from "../../../shared/components/Loader";
import { useAppDispatch, useAppSelector } from "../../../shared/hooks/sharedHooks";
import ActionToast from "../../../shared/components/ActionToast";
import {
  changeQuery,
  getAdminMachines,
  /* WhatsApp sunset 2026-03-14 — channel deactivated, web chat is sole channel */
  // setBotActivation,
  // setSuccess,
  clearSuccess,
  AdminMachinesState
} from "../../adminMachinesSlice";
import { AdminMachine } from "../../api/adminMachinesApi";
import Table from "../../../shared/components/tables/Table";
import SortTableHead, { TableColumnDefinition } from "../../../shared/components/SortTableHead";
import TablePagination from "../../../shared/components/tables/TablePagination";
/* WhatsApp sunset 2026-03-14 — channel deactivated, web chat is sole channel */
// import TableActionButton from "../../../shared/components/tables/TableActionButton";
// import { useConfirmation } from "../../../shared/components/confirmation/ConfirmationProvider";
import AdminSearch from "../AdminSearch";

enum MachinesSortParameter {
  CustomerName = 0,
  ManufacturerName = 1,
  Model = 2,
  TypeName = 3,
  BotActivated = 4,
  CreatedDate = 5,
  ModifiedDate = 6
}

const Machines = () => {
  const { query, machines, loading, success, error } =
    useAppSelector<AdminMachinesState>((state: any) => state.adminMachines);

  const dispatch = useAppDispatch();
  /* WhatsApp sunset 2026-03-14 — channel deactivated, web chat is sole channel */
  // const confirm = useConfirmation();

  /* WhatsApp sunset 2026-03-14 — channel deactivated, web chat is sole channel */
  // const [botFilter, setBotFilter] = useState<string>("all");

  const columns: TableColumnDefinition[] = [
    { title: "Customer", parameter: MachinesSortParameter.CustomerName },
    { title: "Brand", parameter: MachinesSortParameter.ManufacturerName },
    { title: "Model", parameter: MachinesSortParameter.Model },
    { title: "Type", parameter: MachinesSortParameter.TypeName },
    { title: "S/N" },
    { title: "System" },
    /* WhatsApp sunset 2026-03-14 — channel deactivated, web chat is sole channel */
    // { title: "Bot Status", parameter: MachinesSortParameter.BotActivated },
    { title: "Last Modified", parameter: MachinesSortParameter.ModifiedDate },
    /* WhatsApp sunset 2026-03-14 — actions column was bot enable/disable */
    // { title: undefined }
  ];

  const handleSearch = (value?: string) => {
    const newQuery = { ...query, search: value, pageNo: 1 };
    dispatch(changeQuery(newQuery));
    dispatch(getAdminMachines(newQuery));
  };

  const handleSort = (parameter: number) => {
    const sortDesc = query.sortBy !== parameter ? false : !query.sortDesc;
    const newQuery = { ...query, sortBy: parameter, sortDesc: sortDesc };

    dispatch(changeQuery(newQuery));
    dispatch(getAdminMachines(newQuery));
  };

  /* WhatsApp sunset 2026-03-14 — channel deactivated, web chat is sole channel */
  // const handleBotFilterChange = (event: SelectChangeEvent) => {
  //   const value = event.target.value;
  //   setBotFilter(value);
  //
  //   let botActivated: boolean | undefined = undefined;
  //   if (value === "enabled") botActivated = true;
  //   if (value === "disabled") botActivated = false;
  //
  //   const newQuery = { ...query, botActivated, pageNo: 1 };
  //   dispatch(changeQuery(newQuery));
  //   dispatch(getAdminMachines(newQuery));
  // };

  /* WhatsApp sunset 2026-03-14 — channel deactivated, web chat is sole channel */
  // const handleEnableBot = async (machine: AdminMachine) => {
  //   confirm({
  //     title: "Enable AI Bot",
  //     text: `Enable AI assistant for ${machine.model} (${machine.customerName})? Ensure vector index is created first.`,
  //     confirmButton: "Enable",
  //     closeButton: "Cancel",
  //     severity: "neutral",
  //     onConfirm: async () => {
  //       await dispatch(setBotActivation({ id: machine.id, isActivated: true }));
  //       dispatch(setSuccess(`AI Bot enabled for ${machine.model}`));
  //       await dispatch(getAdminMachines(query));
  //     }
  //   });
  // };

  // const handleDisableBot = async (machine: AdminMachine) => {
  //   confirm({
  //     title: "Disable AI Bot",
  //     text: `Disable AI assistant for ${machine.model} (${machine.customerName})? Customer will lose WhatsApp bot access.`,
  //     confirmButton: "Disable",
  //     closeButton: "Cancel",
  //     severity: "error",
  //     onConfirm: async () => {
  //       await dispatch(setBotActivation({ id: machine.id, isActivated: false }));
  //       dispatch(setSuccess(`AI Bot disabled for ${machine.model}`));
  //       await dispatch(getAdminMachines(query));
  //     }
  //   });
  // };

  const handlePageSizeChange = async (size: number) => {
    const newQuery = { ...query, pageNo: 1, pageSize: size };
    await dispatch(changeQuery(newQuery));
    dispatch(getAdminMachines(newQuery));
  };

  const handlePageNoChange = async (no: number) => {
    const newQuery = { ...query, pageNo: no };
    await dispatch(changeQuery(newQuery));
    dispatch(getAdminMachines(newQuery));
  };

  useEffect(() => {
    dispatch(getAdminMachines(query));
  }, []);

  const getBrandDisplay = (machine: AdminMachine) => {
    return machine.manufacturerName || machine.customBrandName || "—";
  };

  return (
    <>
      <Box className="flex flex-col gap-6">
        <Box className="flex justify-between items-center gap-4">
          <Box className="heading-1">Machines</Box>

          <Box className="flex gap-2">
            {/* WhatsApp sunset 2026-03-14 — channel deactivated, web chat is sole channel */}
            {/* <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel>Bot Status</InputLabel>
              <Select
                value={botFilter}
                label="Bot Status"
                onChange={handleBotFilterChange}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="enabled">Enabled</MenuItem>
                <MenuItem value="disabled">Disabled</MenuItem>
              </Select>
            </FormControl> */}

            <AdminSearch onSearch={handleSearch} />
          </Box>
        </Box>

        {loading && <Loader />}

        {!loading && (
          <>
            <Table>
              <SortTableHead
                columns={columns}
                onSort={handleSort}
                sortBy={query.sortBy}
                sortDesc={query.sortDesc}
              />

              <TableBody>
                {machines.items.map((machine) => (
                  <TableRow key={machine.id}>
                    <TableCell>
                      <Box className="text-14-medium">{machine.customerName}</Box>
                    </TableCell>

                    <TableCell>
                      <Box className="text-14-regular">{getBrandDisplay(machine)}</Box>
                    </TableCell>

                    <TableCell>
                      <Box className="text-14-medium">{machine.model}</Box>
                      <Box className="text-12-regular text-gray-600">
                        #{machine.internalNumber}
                      </Box>
                    </TableCell>

                    <TableCell>
                      <Box className="text-14-regular">{machine.typeName || "—"}</Box>
                    </TableCell>

                    <TableCell>
                      <Box className="text-14-regular">{machine.serialNumber || "—"}</Box>
                    </TableCell>

                    <TableCell>
                      <Box className="text-14-regular">{machine.system || "—"}</Box>
                      {machine.version && (
                        <Box className="text-12-regular text-gray-600">
                          v{machine.version}
                        </Box>
                      )}
                    </TableCell>

                    {/* WhatsApp sunset 2026-03-14 — channel deactivated, web chat is sole channel */}
                    {/* <TableCell>
                      {machine.botActivated ? (
                        <Chip
                          icon={<CheckCircleIcon />}
                          label="Active"
                          color="success"
                          size="small"
                        />
                      ) : (
                        <Chip
                          icon={<CancelIcon />}
                          label="Inactive"
                          color="default"
                          size="small"
                        />
                      )}
                    </TableCell> */}

                    <TableCell>
                      <Moment format="DD.MM.YYYY HH:mm">
                        {machine.modifiedDate}
                      </Moment>
                    </TableCell>

                    {/* WhatsApp sunset 2026-03-14 — channel deactivated, web chat is sole channel */}
                    {/* <TableCell>
                      <TableActionButton>
                        {!machine.botActivated && (
                          <MenuItem onClick={() => handleEnableBot(machine)}>
                            <CheckCircleIcon />
                            Enable AI Bot
                          </MenuItem>
                        )}

                        {machine.botActivated && (
                          <MenuItem onClick={() => handleDisableBot(machine)}>
                            <CancelIcon />
                            Disable AI Bot
                          </MenuItem>
                        )}
                      </TableActionButton>
                    </TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>

            <TablePagination
              totalCount={machines.totalCount}
              pageNo={query.pageNo}
              pageSize={query.pageSize}
              onPageSizeChange={handlePageSizeChange}
              onPageNoChange={handlePageNoChange}
            />
          </>
        )}
      </Box>

      <ActionToast
        open={!!success}
        variant="success"
        message={success || ""}
        onClose={() => dispatch(clearSuccess())}
        duration={6000}
      />

      <ActionToast
        open={!!error}
        variant="error"
        message={error || "An error occurred"}
        onClose={() => dispatch(clearSuccess())}
        duration={6000}
      />
    </>
  );
};

export default Machines;
